module.exports = __webpack_public_path__ + "img/Want Av Sight 01.9038179e.png";